import { activityLog } from '@/mocks/orders';

export default function ActivityLog() {
  return (
    <div className="bg-white rounded-xl border border-stone-200/80 overflow-hidden">
      <div className="px-5 py-4 border-b border-stone-100">
        <h3 className="text-sm font-semibold text-stone-800">Son Aktiviteler</h3>
      </div>
      <div className="divide-y divide-stone-50">
        {activityLog.slice(0, 8).map((item) => (
          <div key={item.id} className="flex items-center gap-3 px-5 py-3">
            <div className="w-2 h-2 rounded-full bg-gold-500 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-stone-700">
                <span className="font-medium text-stone-800">{item.orderId}</span>
                {' '}·{' '}
                <span className="text-stone-500">{item.action}</span>
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <span className="text-xs text-stone-400">{item.user}</span>
              <span className="text-xs text-stone-300">·</span>
              <span className="text-xs text-stone-400 whitespace-nowrap">{item.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}